import { Data } from './data';
import { Tarif } from './tarif';

export class Plantarifaire extends Data {

    designation: string;
    tarifs: Tarif[];

    constructor() {

        super();
        // this.montant = 0;
    }

    /* get text(): string{

        return this.designation;
    }

    get value(): number{

        return this.id;
    } */



}
